import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: 0,
    situacao: null,
    mensagem: null,

  },
  /* --------   verifica feriado bancario --------  */
  mutations: {
    SET_DISPONIBILIDADE_SISTEMA(state, payload) {
      state.situacao = payload.situacao;
      state.mensagem = payload.mensagem;
      state.menu = payload.menu;    
    },

    increment (state) {
      state.count++
    }
  },
})

export default store;